/* eslint-disable react/style-prop-object */


import { useLayoutEffect, useRef, useState } from "react";
import { CheckCircle } from "react-bootstrap-icons";
import ToggleButton from "../../../../../../components/ui/toggle_button/ToggleButton";

export default function SingleSelectionComponent({
    component,
    onUserInput,
    onUserInputComplete,
    defaultValues,
    showStatus
}) {

    const displayAs =
        !Array.isArray(component.properties) ?
            [] :
            (component.properties && (component.properties.find(a => a.property === "displayAs")) && component.properties.find(a => a.property === "displayAs").values)
    const options = !Array.isArray(component.properties) ?
        [] :
        (component.properties && component.properties.find(a => a.property === "Options")) ? JSON.parse(component.properties.find(a => a.property === "Options").values) : []

    const parentRef = useRef(null);
    const [statsStyle, setStatsStyle] = useState({ top: 0, left: 0 });

    let _defaultValue = defaultValues;
    if (typeof defaultValues === 'string' && defaultValues.startsWith('{')) {

        // Historic formats
        try {
            console.warn("Parsing defaultValues as JSON for backwards compatibility", defaultValues);
            _defaultValue = JSON.parse(defaultValues);
            if (Object.keys(_defaultValue).length > 0 && _defaultValue.hasOwnProperty('option')) {
                _defaultValue = _defaultValue.option;
                console.warn("Translated to new format", _defaultValue);
            }
        } catch (e) {
            console.error("Error parsing defaultValues as JSON", e);
        }
    }

    useLayoutEffect(() => {
        if (showStatus && parentRef.current) {
            const rect = parentRef.current.getBoundingClientRect();
            setStatsStyle({
                top: rect.top,
                left: rect.right - 350 // 350 is minWidth of stats container
            });
        }
    }, [showStatus]);

    return (
        <div ref={parentRef}>
            {/* {showStatus && component.properties && ReactDOM.createPortal(
                <div className="stats-container d-flex flex-column justify-content-between mb-2 shadow p-1 rounded position-fixed" style={{ top: statsStyle.top, left: statsStyle.left, minWidth: 350, zIndex: 9999 }}>
                    <b>Stats (Weights)</b>
                    {
                        component.properties.find(a => a.property === 'Options')
                        && (
                            (
                                typeof component.properties.find(a => a.property === 'Options').values === 'string'
                                &&
                                (
                                    component.properties.find(a => a.property === 'Options').values.startsWith('{') ||
                                    component.properties.find(a => a.property === 'Options').values.startsWith('[')
                                )
                            )
                        )
                        && (Object.keys(JSON.parse(component.properties.find(a => a.property === 'Options').values)))
                            .map((key) => {
                                const property = JSON.parse(component.properties.find(a => a.property === 'Options').values)[key]
                                if (property.option && property.weight)
                                    return <small key={key}
                                        className={`d-flex justify-content-between small opacity-75 p-1 rounded-2 ${defaultValues === property.option ? '75 bg-primary-container text-light' : ' text-muted '}`}
                                    >
                                        <div className="small">{property.option}</div>
                                        <div className="small">{property.weight}</div>
                                    </small>
                                else
                                    return <></>
                            })
                    }
                </div>, document.body) */}
            {/* } */}
            {
                {
                    "Buttons": <div>
                        {options.map(option => <button type="button" key={`button-${option.option}`} className={`btn w-100 ${_defaultValue === option.option ? 'bg-primary-container' : 'bg-secondary-container'}`}
                            onClick={e => { onUserInput(option.option); onUserInputComplete && onUserInputComplete(option.option); }}
                        >{_defaultValue && _defaultValue === option.option && <CheckCircle />} {option.option}</button>)}
                    </div>,
                    "Dropdown": <select
                        className="form-control form-control-sm"
                        defaultValue={_defaultValue}
                        onChange={e => { onUserInput(e.target.value); onUserInputComplete && onUserInputComplete(e.target.value); }}
                    >{options.map(option => <option key={`option-${option.option}`} value={option.option}>{option.option}</option>)}</select>,
                }[displayAs] || <div>
                    {options.map(option =>
                        <ToggleButton key={`ToggleButton-${option.option}`} style='tick' defaultValue={option.option === _defaultValue} onToggle={_ => {
                            onUserInput(option.option)
                            onUserInputComplete && onUserInputComplete(option.option);
                        }}>
                            {option.option}
                        </ToggleButton>
                    )}
                </div>
            }
        </div>
    )
}
